'use strict';

/**
 * Created by MRQ on 2016/1/18.
 */
angular.module('reserveModalModule', []).controller('reserveModalCtrl', [
    '$scope',
    '$validation',
    '$q',
    '$modalInstance',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'items',
    '$filter',
    'editingCenterService',
    'trsColumnTreeLocationService',
    'trsspliceString',
    'isUgc',
    function (
        $scope,
        $validation,
        $q,
        $modalInstance,
        $timeout,
        trsHttpService,
        modalDialog,
        items,
        $filter,
        editingCenterService,
        trsColumnTreeLocationService,
        trsspliceString,
        isUgc,
    ) {
        // var $scope.selectChanel = [];
        var now = new Date();
        $scope.PaperPubDate = now.setDate(now.getDate() + 1);
        $scope.selectChanel = [];
        $scope.Delay = 1;
        // 初始化数据
        initStatus();
        initData();

        // 切换tab选型卡
        $scope.setCurrMedia = function (media) {
            $scope.currMedia = media.mediaType;
            var temp = media.mediaValue.replace(/(\w)/, function (v) {
                return v.toUpperCase();
            }); // 首字母大写
            // if('Weixin,Weibo,tiktok,baijiahao,TouTiao,penguin'.indexOf(temp)){
            //     requestGener(media);
            // }else{
            if (temp != 'Iwo') {
                eval('request' + temp + '()');
            }
            // }
        };

        // 关闭窗口
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        // 关闭窗口
        $scope.confirm = function () {
            $modalInstance.dismiss();
        };

        $scope.changeRadioStatus = function () {
            // $scope.selectChanel.ToMy.isShow = !$scope.selectChanel.ToMy.isShow;
            var iwoSelected = {
                isShow: true,
                label: $scope.mediasArray[0].mediaName,
                name: 'ToMy',
            };
            var iwoIsSelected = false;
            var iwoIndex;
            angular.forEach($scope.selectChanel, function (data, index) {
                if (data.name == 'ToMy') {
                    iwoIsSelected = true;
                    iwoIndex = index;
                }
            });
            if (iwoIsSelected === false) {
                $scope.selectChanel.push(iwoSelected);
                $scope.selectCollect.iwo = true;
            } else {
                $scope.selectChanel.splice(iwoIndex, 1);
                $scope.selectCollect.iwo = false;
            }
        };
        // $scope.changeSingleRadio = function(node) {
        //     $scope.selectChanel.Web = {
        //         label: $scope.mediasArray[2].mediaName + ">" + $scope.selectCollect.websiteSiteItem.SITEDESC + ">" + node.CHNLDESC,
        //         isShow: true,
        //         item: node
        //     };
        // };
        $scope.selectPaperItem = function (item, index) {
            if ($scope.selectCollect.selectCaiBian[$scope.selectCollect.selectNewspaper.SITEID] == item) {
                delete $scope.selectCollect.selectCaiBian[$scope.selectCollect.selectNewspaper.SITEID];
            } else {
                $scope.selectCollect.selectCaiBian[$scope.selectCollect.selectNewspaper.SITEID] = item;
            }
            var newspaperSelected = {
                label:
                    $scope.mediasArray[1].mediaName +
                    '>' +
                    $scope.selectCollect.selectNewspaper.SITEDESC +
                    '>' +
                    $scope.NewspaperDieCiData[$scope.selectCollect.selectDieCi].CHNLDESC +
                    '>' +
                    item.CHNLDESC,
                isShow: true,
                key: item.SITEID,
                id: item.CHANNELID,
                name: 'Paper',
            };
            refreshSelectedChnl(newspaperSelected);
        };

        /* $scope.chooseChannel = function(node, type) {
            if (type == 'website') {
                $scope.selectedNode = node;
            } else if (type == 'app') {
                $scope.appSelectedNode = node;
            }
        };*/
        // 初始化数据
        function initData() {
            getAccessAuthority().then(function () {
                calcuAccessbleChannel();
            });
        }
        /**
         * [initStatus description]
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // 当前选项卡
            $scope.currMedia = -1;
            // 标题列表是否出现
            $scope.isTitleMoreShow = false;
            $scope.status = {
                accessAuthority: {
                    iwo: false,
                    app: false,
                    website: false,
                    newspaper: false,
                    weixin: false,
                    weibo: false,
                    douyin: false,
                    baijiahao: false,
                    toutiao: false,
                    qiehao: false,
                },
                delay: true,
                accessibleChannel: 0,
                rightCount: 0,
                isShowWeibo: true,
                isNavMove: false,
            };
            $scope.navStyle = {
                'margin-left': '0px',
            };
            // 选项卡初始化
            $scope.mediasArray = [
                {
                    mediaName: '我的',
                    mediaType: -1,
                    mediaValue: 'iwo',
                },
                {
                    mediaName: '纸媒',
                    mediaType: 3,
                    mediaValue: 'newspaper',
                },
                {
                    mediaName: '网站',
                    mediaType: 2,
                    mediaValue: 'website',
                },
                {
                    mediaName: 'APP',
                    mediaType: 1,
                    mediaValue: 'app',
                },
                {
                    mediaName: '微信',
                    mediaType: 4,
                    mediaValue: 'weixin',
                },
                {
                    mediaName: '微博',
                    mediaType: 5,
                    mediaValue: 'weibo',
                },
                {
                    mediaName: '抖音',
                    mediaType: 17,
                    mediaValue: 'douyin',
                },
                {
                    mediaName: '百家号',
                    mediaType: 18,
                    mediaValue: 'baijiahao',
                },
                {
                    mediaName: '企鹅号',
                    mediaType: 19,
                    mediaValue: 'qiehao',
                },
                {
                    mediaName: '头条号',
                    mediaType: 20,
                    mediaValue: 'toutiao',
                },
            ];
            $scope.webExpandedTest = [];
            $scope.appExpandedTest = [];
            $scope.websiteSiteData = [];
            $scope.appSiteData = [];
            $scope.weixinData = [];
            $scope.weiboData = [];
            $scope.douyinData = [];
            $scope.baijiahaoData = [];
            $scope.toutiaoData = [];
            $scope.qiehaoData = [];
            $scope.appSelectedNode = {};
            $scope.selectedNode = {};
            $scope.NewspaperParams = {
                serviceid: 'mlf_paper',
                methodname: 'queryPagers',
            };
            $scope.selectCollect = {
                websiteSite: '',
                appSite: '',
                weixin: [],
                weibo: [],
                douyin: [],
                baijiahao: [],
                toutiao: [],
                qiehao: [],
                iwo: false,
                selectNewspaper: '',
                selectDieCi: 0,
                selectCaiBian: {},
            };
            $scope.data = {
                selectedWeiboType: '16',
                conLeftData: [
                    {
                        mediaValue: 'weixin',
                        listName: '微信列表',
                        mediaName: '微信',
                        type: 'WeChat',
                        mediaType: 4,
                        isShow: true,
                    },
                    {
                        mediaValue: 'weibo',
                        listName: '微博列表',
                        mediaName: '微博',
                        type: 'WeiBo',
                        mediaType: 5,
                        isShow: true,
                    },
                    {
                        mediaValue: 'douyin',
                        listName: '抖音列表',
                        mediaName: '抖音',
                        type: 'tiktok',
                        mediaType: 17,
                        isShow: true,
                    },
                    {
                        mediaValue: 'baijiahao',
                        listName: '百家号列表',
                        mediaName: '百家号',
                        type: 'baijiahao',
                        mediaType: 18,
                        isShow: true,
                    },
                    {
                        mediaValue: 'qiehao',
                        listName: '企鹅号列表',
                        mediaName: '企鹅号',
                        type: 'penguin',
                        mediaType: 19,
                        isShow: true,
                    },
                    {
                        mediaValue: 'toutiao',
                        listName: '头条号列表',
                        mediaName: '头条号',
                        type: 'TouTiao',
                        mediaType: 20,
                        isShow: true,
                    },
                ],
                trackData: [
                    {
                        trackName: '我的',
                        type: 'iwo',
                        accessName: 'iwo',
                        isShow: true,
                    },
                    {
                        trackName: '纸媒',
                        type: 'Paper',
                        accessName: 'newspaper',
                        isShow: true,
                    },
                    {
                        trackName: '网站',
                        type: 'Web',
                        accessName: 'website',
                        isShow: true,
                    },
                    {
                        trackName: 'APP',
                        type: 'MlfApp',
                        accessName: 'app',
                        isShow: true,
                    },
                    {
                        trackName: '微信',
                        type: 'WeChat',
                        accessName: 'weixin',
                        isShow: true,
                    },
                    {
                        trackName: '微博',
                        type: 'WeiBo',
                        accessName: 'weibo',
                        isShow: false,
                    },
                    {
                        trackName: '抖音',
                        type: 'tiktok',
                        accessName: 'douyin',
                        isShow: true,
                    },
                    {
                        trackName: '百家号',
                        type: 'baijiahao',
                        accessName: 'baijiahao',
                        isShow: true,
                    },
                    {
                        trackName: '企鹅号',
                        type: 'penguin',
                        accessName: 'qiehao',
                        isShow: true,
                    },
                    {
                        trackName: '头条号',
                        type: 'TouTiao',
                        accessName: 'toutiao',
                        isShow: true,
                    },
                ],
                weibo: [],
                douyin: [],
                weixin: [],
                baijiahao: [],
                toutiao: [],
                qiehao: [],
            };

            var channel = '',
                depart = '',
                totalWords = 0,
                docIds = '',
                title = '';
            angular.forEach(items, function (n, i) {
                channel += ',' + n.DOCCHANNEL;
                depart += ',' + n.ZB_SOURCE_SITE;
                docIds += ',' + n.ZB_GUID;
                totalWords += Number(n.TXS);
                n.DOCTITLE = n.DOCTITLE || n.TITLE; // 共享稿库和其他几个列表返回字段不同
            });
            title = items.length > 1 ? '多篇提交' : items[0].DOCTITLE;

            $scope.selectDocsInfo = {
                channel: channel.substr(1),
                depart: depart.substr(1),
                size: items.length,
                totalWords: totalWords,
                title: title,
                items: items,
            };
            // ChnlDocIds = docIds.substr(1);
        }

        /**
         * [showWeibo description] 是否展示微博渠道
         * @return {[type]} [description]
         */
        function showWeibo() {
            if (!items || !hasFusionWeibo()) {
                $scope.mediasArray.splice(5, 1);
            }

            /**
             * [hasFusionWeibo description] 是否都是融合微博
             * @return {Boolean} [description]
             */
            function hasFusionWeibo() {
                return items.every(function (item, index) {
                    return (
                        item.relatedMedias &&
                        item.relatedMedias instanceof Array &&
                        item.relatedMedias.some(function (_item, _index) {
                            return _item.MEDIATYPE == 5;
                        })
                    );
                });
            }
        }

        /**
         * [getAccessAuthority description]判断渠道下权限
         * @return {[type]} [description]
         */
        function getAccessAuthority() {
            var deferred = $q.defer();
            var docType = angular.isDefined(items) ? items[0].DOCTYPEID : undefined;
            var trench;
            editingCenterService.getPermissions(docType, false).then(function (data) {
                for (var i in data) {
                    if (!trench) {
                        trench = i;
                    }
                    $scope.status.accessAuthority[i] = true;
                }
                for (var j = 0; j < $scope.mediasArray.length; j++) { // 由于iwo没法匹配所有类型稿件（音频、链接等）所以需要根据权限获取默认选中的渠道
                    if ($scope.mediasArray[j].mediaValue === trench) {
                        $scope.status.selectedMedia = $scope.mediasArray[j];
                        $scope.setCurrMedia($scope.status.selectedMedia);
                        break;
                    }
                }
                deferred.resolve($scope.status.accessAuthority);
            });
            return deferred.promise;
        }
        $scope.sendTimeSigned = function () {
            var timeSigned = $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
            $modalInstance.close(timeSigned);
        };

        /**
         *[getSuggestions description]搜索栏目
         * @param  {[type]}channelname  [description] 输入栏目名称
         * return {[type]}   null  [description]
         */
        var promise;
        $scope.getSuggestions = function (channelName, type) {
            if (channelName === '') {
                return;
            }
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            var siteid = type == 'website' ? $scope.selectCollect.websiteSite : $scope.selectCollect.appSite;
            promise = $timeout(function () {
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryRightClassifyByName',
                    ChannelName: channelName,
                    SiteId: siteid,
                };
                return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    return data;
                });
            }, 500);
            return promise;
        };
        $scope.$watch('data.channelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                requestTree($scope.selectCollect.websiteSite, 'website', 1);
                $scope.webExpandedTest = [];
                trsColumnTreeLocationService.columnTreeLocation(
                    1,
                    newValue.CHANNELID,
                    $scope.selectCollect.websiteSiteItem.TREE,
                    $scope.website_selectedNode,
                    $scope.webExpandedTest,
                    function (tree, array, selectedNode) {
                        delete $scope.selectCollect.websiteSiteItem.TREE;
                        $scope.selectCollect.websiteSiteItem.TREE = tree;
                        $scope.selectedNode = selectedNode;
                        $scope.showSelected($scope.selectedNode, 'website');
                    }
                );
            }
        });
        $scope.$watch('data.appChannelFilter', function (newValue, oldValue) {
            if (angular.isObject(newValue)) {
                requestTree($scope.selectCollect.appSite, 'app', 7);
                $scope.appExpandedTest = [];
                trsColumnTreeLocationService.columnTreeLocation(
                    7,
                    newValue.CHANNELID,
                    $scope.selectCollect.appSiteItem.TREE,
                    $scope.app_selectedNode,
                    $scope.appExpandedTest,
                    function (tree, array, selectedNode) {
                        delete $scope.selectCollect.appSiteItem.TREE;
                        $scope.selectCollect.appSiteItem.TREE = tree;
                        $scope.appSelectedNode = selectedNode;
                        $scope.showSelected($scope.appSelectedNode, 'app');
                    }
                );
            }
        });
        // 树配置开始
        $scope.treeOptions = {
            nodeChildren: 'CHILDREN',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'a3',
                iCollapsed: 'a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'take-draft-tree-label-sel',
            },
            isLeaf: function (node) {
                return node.CHILDREN == undefined;
            },
        };
        // 折叠时触发函数
        $scope.showToggle = function (node, platform) {
            if (node.HASCHILDREN === 'false' || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length > 0)) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyByChnl',
                ChannelId: node.CHANNELID,
                platform: platform,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                node.CHILDREN = data.CHILDREN;
            });
        };
        // 选中时触发函数
        $scope.showSelected = function (node, type) {
            if (!node.CHNLDESC) {
                return false;
            }
            if (type == 'website') {
                if ($scope.selectedNode[node.SITEID] == node) {
                    delete $scope.selectedNode[node.SITEID];
                } else {
                    $scope.selectedNode[node.SITEID] = node;
                }
                var websiteSelected = {
                    label:
                        $scope.mediasArray[2].mediaName +
                        '>' +
                        $scope.selectCollect.websiteSiteItem.SITEDESC +
                        '>' +
                        (node.CHNLDESC || node.SITEDESC),
                    isShow: true,
                    key: node.SITEID,
                    id: node.CHANNELID,
                    name: 'Web',
                };
                refreshSelectedChnl(websiteSelected);
            } else if (type == 'app') {
                var isChecked = node == $scope.appSelectedNode[$scope.selectCollect.appSite];
                appChannelAvailable(node, isChecked).then(function () {
                    if ($scope.appSelectedNode[node.SITEID] == node) {
                        delete $scope.appSelectedNode[node.SITEID];
                    } else {
                        $scope.appSelectedNode[node.SITEID] = node;
                    }
                    var appSelected = {
                        label:
                            $scope.mediasArray[3].mediaName +
                            '>' +
                            $scope.selectCollect.appSiteItem.SITEDESC +
                            '>' +
                            (node.CHNLDESC || node.SITEDESC),
                        isShow: true,
                        key: node.SITEID,
                        id: node.CHANNELID,
                        name: 'MlfApp',
                    };
                    refreshSelectedChnl(appSelected);
                });
            }
        };

        /**
         * [appChannelAvailable description] APP栏目是否允许该类型稿件创建
         * @param {[type]} [node] [description] 所选节点
         * @return {[type]} [description]
         */
        function appChannelAvailable(node, isChecked) {
            var defer = $q.defer();
            if (isUgc) {
                defer.resolve();
            } else if (isChecked) {
                defer.resolve();
            } else if (angular.isUndefined(items[0].METADATAID)) {
                defer.resolve();
            } else {
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'checkCanSubmitToChannel',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                    channelId: node.CHANNELID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve();
                });
            }
            return defer.promise;
        }
        // 请求网站站点列表
        function requestWebsite() {
            if ($scope.websiteSiteData.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 2,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.websiteSiteData = data.DATA;
                $scope.selectCollect.websiteSite = $scope.websiteSiteData[0].SITEID;
                $scope.selectCollect.websiteSiteItem = $scope.websiteSiteData[0];
                requestTree($scope.selectCollect.websiteSite, 'website', 1);
            });
        }
        // 请求APP站点列表
        function requestApp() {
            if ($scope.appSiteData.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 1,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.appSiteData = data.DATA;
                if ($scope.appSiteData[0].SITETYPE != '-1') {
                    $scope.selectCollect.appSite = $scope.appSiteData[0].SITEID;
                    $scope.selectCollect.appSiteItem = $scope.appSiteData[0];
                } else {
                    $scope.selectCollect.appSite = $scope.appSiteData[1].SITEID;
                    $scope.selectCollect.appSiteItem = $scope.appSiteData[1];
                }
                requestTree($scope.selectCollect.appSite, 'app', 7);
            });
        }

        // 请求微信站点列表
        function requestGener(media) {
            if ($scope.data[media.mediaValue].length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: media.mediaType,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data[media.mediaValue] = data.DATA;
            });
        }

        // 请求微信站点列表
        function requestWeixin() {
            if ($scope.data.weixin.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 4,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.weixin = data.DATA;
            });
        }

        /**
         * [requestWeibo description] 请求微博账号
         * @return {[type]} [description]
         */
        function requestWeibo() {
            if ($scope.data.weibo.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 5,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHANNELID = item.ACCOUNTID;
                    item.CHNLDESC = item.ACCOUNTNAME;
                });
                $scope.data.weibo = data.DATA;
            });
        }

        /**
         * [requestDouyin description] 请求微博账号
         * @return {[type]} [description]
         */
        function requestDouyin() {
            if ($scope.data.douyin.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 17,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHANNELID = item.DOUYINACCOUNTID;
                    item.CHNLDESC = item.ACCOUNTNAME;
                });
                $scope.data.douyin = data.DATA;
            });
        }

        /**
         * [requestDouyin description] 请求微博账号
         * @return {[type]} [description]
         */
        function requestBaijiahao() {
            if ($scope.data.baijiahao.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 18,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHANNELID = item.BAIJIAHAOACCOUNTID;
                    item.CHNLDESC = item.ACCOUNTNAME;
                });
                $scope.data.baijiahao = data.DATA;
            });
        }

        /**
         * [requestDouyin description] 请求微博账号
         * @return {[type]} [description]
         */
        function requestToutiao() {
            if ($scope.data.toutiao.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 20,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHANNELID = item.CHANNELID;
                    item.CHNLDESC = item.CHNLNAME;
                });
                $scope.data.toutiao = data.DATA;
            });
        }

        /**
         * [requestDouyin description] 请求微博账号
         * @return {[type]} [description]
         */
        function requestQiehao() {
            if ($scope.data.qiehao.length > 0) {
                return;
            }
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryWebSitesByMediaType',
                MediaType: 19,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                data.DATA.forEach(function (item, index) {
                    item.CHANNELID = item.ACCOUNTID;
                    item.CHNLDESC = item.ACCOUNTNAME;
                });
                $scope.data.qiehao = data.DATA;
            });
        }

        // 请求网站的树
        $scope.setSelectedTree = function (item, type) {
            if (type == 'website') {
                $scope.selectCollect.websiteSite = item.SITEID;
                $scope.selectCollect.websiteSiteItem = item;
            } else if (type == 'app') {
                $scope.selectCollect.appSite = item.SITEID;
                $scope.selectCollect.appSiteItem = item;
            }
            requestTree(item.SITEID, type, 1);
        };

        function requestTree(siteId, type, platform) {
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryClassifyBySite',
                SiteId: siteId,
                platform: platform, // 预留都是留到待编，网站待编platform为1，客户端待编platform为7
            };
            if (type == 'website') {
                if (!!$scope.selectCollect.websiteSiteItem.TREE) {
                    return;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.selectCollect.websiteSiteItem.TREE = data;
                });
            } else if (type == 'app') {
                if (!!$scope.selectCollect.appSiteItem.TREE) {
                    return;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.selectCollect.appSiteItem.TREE = data;
                });
            }
        }
        // 展开的树
        function ExpandedNodes(expandedTest, dataForTheTree) {
            expandedTest = [];
            expandedTest.push(dataForTheTree[0]);
        }
        $scope.selectedWeixin = function (item) {
            if ($scope.selectCollect.weixin.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.weixin.push(item.CHANNELID);
                $scope.selectCollect.weixinItem = item;
                var weixinSelected = {
                    label: $scope.mediasArray[4].mediaName + '>' + $scope.selectCollect.weixinItem.CHNLDESC,
                    isShow: true,
                    key: 'weixin',
                    id: item.CHANNELID,
                    name: 'WeChat',
                };
                refreshSelectedChnl(weixinSelected);
            } else {
                $scope.selectCollect.weixin.splice($scope.selectCollect.weixin.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };
        $scope.selectedWeibo = function (item) {
            if ($scope.selectCollect.weibo.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.weibo.push(item.CHANNELID);
                $scope.selectCollect.weiboItem = item;
                var weiboSelected = {
                    label: $scope.mediasArray[5].mediaName + '>' + $scope.selectCollect.weiboItem.CHNLDESC,
                    isShow: true,
                    key: 'weibo',
                    id: item.CHANNELID,
                    name: 'WeiBo',
                };
                refreshSelectedChnl(weiboSelected);
            } else {
                $scope.selectCollect.weibo.splice($scope.selectCollect.weibo.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };

        $scope.selectedItem = function (site, item) {
            if ($scope.selectCollect[site.mediaValue].indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect[site.mediaValue].push(item.CHANNELID);
                $scope.selectCollect[site.mediaValue + 'Item'] = item;
                var itemSelected = {
                    label: site.mediaName + '>' + $scope.selectCollect[site.mediaValue + 'Item'].CHNLDESC,
                    isShow: site.isShow,
                    key: site.mediaValue,
                    id: item.CHANNELID,
                    name: site.type,
                };
                refreshSelectedChnl(itemSelected);
            } else {
                $scope.selectCollect.weibo.splice($scope.selectCollect.weibo.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };

        $scope.selectedDouyin = function (item) {
            if ($scope.selectCollect.douyin.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.douyin.push(item.CHANNELID);
                $scope.selectCollect.douyinItem = item;
                var douyinSelected = {
                    label: $scope.mediasArray[6].mediaName + '>' + $scope.selectCollect.douyinItem.CHNLDESC,
                    isShow: true,
                    key: 'douyin',
                    id: item.CHANNELID,
                    name: 'tiktok',
                };
                refreshSelectedChnl(douyinSelected);
            } else {
                $scope.selectCollect.douyin.splice($scope.selectCollect.douyin.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };
        $scope.selectedBaijiahao = function (item) {
            if ($scope.selectCollect.baijiahao.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.baijiahao.push(item.CHANNELID);
                $scope.selectCollect.baijiahao = item;
                var baijiahaoSelected = {
                    label: $scope.mediasArray[7].mediaName + '>' + $scope.selectCollect.baijiahaoItem.CHNLDESC,
                    isShow: true,
                    key: 'baijiahao',
                    id: item.CHANNELID,
                    name: 'baijiahao',
                };
                refreshSelectedChnl(baijiahaoSelected);
            } else {
                $scope.selectCollect.baijiahao.splice($scope.selectCollect.baijiahao.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };
        $scope.selectedToutiao = function (item) {
            if ($scope.selectCollect.toutiao.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.toutiao.push(item.CHANNELID);
                $scope.selectCollect.toutiao = item;
                var toutiaoSelected = {
                    label: $scope.mediasArray[8].mediaName + '>' + $scope.selectCollect.toutiaoItem.CHNLDESC,
                    isShow: true,
                    key: 'toutiao',
                    id: item.CHANNELID,
                    name: 'TouTiao',
                };
                refreshSelectedChnl(toutiaoSelected);
            } else {
                $scope.selectCollect.toutiao.splice($scope.selectCollect.toutiao.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };
        $scope.selectedQiehao = function (item) {
            if ($scope.selectCollect.qiehao.indexOf(item.CHANNELID) < 0) {
                $scope.selectCollect.qiehao.push(item.CHANNELID);
                $scope.selectCollect.qiehao = item;
                var qiehaoSelected = {
                    label: $scope.mediasArray[8].mediaName + '>' + $scope.selectCollect.qiehaoItem.CHNLDESC,
                    isShow: true,
                    key: 'qiehao',
                    id: item.CHANNELID,
                    name: 'penguin',
                };
                refreshSelectedChnl(qiehaoSelected);
            } else {
                $scope.selectCollect.qiehao.splice($scope.selectCollect.qiehao.indexOf(item.CHANNELID), 1);
                angular.forEach($scope.selectChanel, function (data, index) {
                    if (data.id == item.CHANNELID) {
                        $scope.removeChannel(index);
                    }
                });
            }
        };
        // 请求媒体列表
        function requestNewspaper(callback) {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.NewspaperParams, 'post').then(function (data) {
                if (angular.isFunction(callback)) {
                    callback(data);
                } else {
                    $scope.NewspaperData = data;
                    $scope.selectCollect.selectNewspaper = data[0];
                    requestNewspaperDieCi($scope.NewspaperData[0].SITEID);
                }
            });
        }
        // 请求叠次报纸
        $scope.requestNewspaperDieCi = function (item) {
            if ($scope.selectCollect.selectNewspaper != item) {
                $scope.selectCollect.selectNewspaper = item;
                $scope.selectCollect.selectDieCi = 0;
                requestNewspaperDieCi(item.SITEID);
            }
        };

        function requestNewspaperDieCi(siteId, callback) {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryDieCis',
                PaperId: siteId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (angular.isFunction(callback)) {
                    callback(data);
                } else {
                    $scope.NewspaperDieCiData = data;
                    requestNewspaperCaiBianFn(siteId, $scope.NewspaperDieCiData[0] && $scope.NewspaperDieCiData[0].CHANNELID);
                }
            });
        }
        // 请求采编版面列表
        $scope.requestNewspaperCaiBian = function (siteId, channelId, index) {
            $scope.selectCollect.selectDieCi = index;
            requestNewspaperCaiBianFn(siteId, channelId);
        };

        function requestNewspaperCaiBianFn(siteId, channelId) {
            var params = {
                serviceid: 'mlf_paper',
                methodname: 'queryCaiBianBanMians',
                PaperId: siteId,
                DieCiId: channelId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                if (data.length < 1) {
                    $scope.NewspaperCaiBianData = 0;
                } else {
                    $scope.NewspaperCaiBianData = data;
                    // $scope.selectCollect.selectCaiBian = {};
                }
            });
        }
        // 判断值的有效性
        function RegData(num) {
            var delay = /^[1-9]\d*$/; // 正整数
            if (num && delay.test(num)) {
                $scope.status.delay = true;
            } else {
                $scope.status.delay = false;
            }
            return $scope.status.delay;
        }

        $scope.regData = RegData;

        // 确定
        $scope.sendInfo = function () {
            $validation
                .validate($scope.timeForm)
                .success(function () {
                    var sendObj = {};
                    var tempObj = {
                        Paper: [],
                        Web: [],
                        MlfApp: [],
                        WeChat: [],
                        tiktok: [],
                        baijiahao: [],
                        TouTiao: [],
                        penguin: [],
                        MicroBlog: [],
                    };
                    for (var name in $scope.selectChanel) {
                        if ($scope.selectChanel[name].isShow) {
                            if ($scope.selectChanel[name].name == 'ToMy') {
                                sendObj[$scope.selectChanel[name].name] = true;
                            } else if ($scope.selectChanel[name].name == 'Paper') {
                                tempObj.Paper.push($scope.selectChanel[name].id);
                                sendObj.PaperPubDate = $scope.PaperPubDate && $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
                            } else if ($scope.selectChanel[name].name == 'Web') {
                                tempObj.Web.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'MlfApp') {
                                tempObj.MlfApp.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'WeChat') {
                                tempObj.WeChat.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'WeiBo') {
                                tempObj.MicroBlog.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'tiktok') {
                                tempObj.tiktok.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'baijiahao') {
                                tempObj.baijiahao.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'TouTiao') {
                                tempObj.TouTiao.push($scope.selectChanel[name].id);
                            } else if ($scope.selectChanel[name].name == 'penguin') {
                                tempObj.penguin.push($scope.selectChanel[name].id);
                            }
                        }
                    }
                    sendObj.Paper = tempObj.Paper.join();
                    sendObj.Web = tempObj.Web.join();
                    sendObj.MlfApp = tempObj.MlfApp.join();
                    sendObj.WeChat = tempObj.WeChat.join();
                    sendObj.MicroBlog = tempObj.MicroBlog.join();
                    sendObj.tiktok = tempObj.tiktok.join();
                    sendObj.baijiahao = tempObj.baijiahao.join();
                    sendObj.TouTiao = tempObj.TouTiao.join();
                    sendObj.penguin = tempObj.penguin.join();
                    sendObj.items = items;
                    sendObj.Delay = $scope.Delay;
                    if (sendObj.MicroBlog.length) {
                        params.microblogDocType = $scope.data.selectedWeiboType;
                    }
                    $modalInstance.close(sendObj);
                })
                .error(function () {
                    modalDialog.alertType('预留天数设置有误', '', 'error', 'confirm');
                });
        };

        $scope.removeChannel = function (key, value) {
            if ($scope.selectChanel[key].name == 'ToMy') {
                $scope.selectCollect.iwo = false;
            }
            if (angular.isDefined(value) && $scope.selectCollect.weixin.indexOf(value.id) >= 0) {
                $scope.selectCollect.weixin.splice($scope.selectCollect.weixin.indexOf(value.id), 1);
            } else if (angular.isDefined(value) && $scope.selectCollect.weibo.indexOf(value.id) >= 0) {
                $scope.selectCollect.weibo.splice($scope.selectCollect.weibo.indexOf(value.id), 1);
            }
            $scope.selectChanel.splice(key, 1);
            delSelectedArrFn(value);
        };

        /**
         * [delSelectedArrFn description] 删除网站和APP中的选中项
         * @param  {[type]} item [description] 当前对象
         * @return {[type]}      [description]
         */
        function delSelectedArrFn(item) {
            switch (item.name) {
                case 'MlfApp':
                    delete $scope.appSelectedNode[item.key];
                    break;
                case 'Web':
                    delete $scope.selectedNode[item.key];
                    break;
                case 'Paper':
                    delete $scope.selectCollect.selectCaiBian[item.key];
                    break;
            }
        }

        // 是否选了渠道
        $scope.hasSelected = function () {
            var sendObj = {};
            var tempObj = {
                Paper: [],
                Web: [],
                MlfApp: [],
                WeChat: [],
                tiktok: [],
                baijiahao: [],
                TouTiao: [],
                penguin: [],
            };
            for (var name in $scope.selectChanel) {
                if ($scope.selectChanel[name].isShow) {
                    if ($scope.selectChanel[name].name == 'ToMy') {
                        sendObj[$scope.selectChanel[name].name] = true;
                    } else if ($scope.selectChanel[name].name == 'Paper') {
                        tempObj.Paper.push($scope.selectChanel[name].id);
                        sendObj.PaperPubDate = $scope.PaperPubDate && $filter('date')($scope.PaperPubDate, 'yyyy-MM-dd').toString();
                    } else if ($scope.selectChanel[name].name == 'Web') {
                        tempObj.Web.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'MlfApp') {
                        tempObj.MlfApp.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'WeChat') {
                        tempObj.WeChat.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'tiktok') {
                        tempObj.WeChat.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'Bijiahao') {
                        tempObj.WeChat.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'TouTiao') {
                        tempObj.WeChat.push($scope.selectChanel[name].id);
                    } else if ($scope.selectChanel[name].name == 'penguin') {
                        tempObj.WeChat.push($scope.selectChanel[name].id);
                    }
                }
            }
            sendObj.Paper = tempObj.Paper.join();
            sendObj.Web = tempObj.Web.join();
            sendObj.MlfApp = tempObj.MlfApp.join();
            sendObj.WeChat = tempObj.WeChat.join();
            var empty = true;
            for (var i in sendObj) {
                if (sendObj[i] !== '') {
                    empty = false;
                    break;
                }
            }
            return empty;
        };

        /**
         * [refreshSelectedChnl description] 更新已选栏目
         * @return {[type]} [description]
         */
        function refreshSelectedChnl(item) {
            var index = queryIndexInSelectedChnl(item.key, item.id);
            if (index > -1) {
                if ($scope.selectChanel[index].label == item.label) {
                    $scope.selectChanel.splice(index, 1);
                    return;
                }
                $scope.selectChanel[index] = item;
            } else {
                $scope.selectChanel.push(item);
            }
        }

        /**
         * [queryIndexInSelectedChnl description]按照key 查询已选
         * @param  {[type]} key [description] key
         * @return {[type]}     [description]
         */
        function queryIndexInSelectedChnl(key, id) {
            for (var i in $scope.selectChanel) {
                if (
                    key != 'weixin' &&
                    key !== 'weibo' &&
                    key != 'baijiahao' &&
                    key != 'qiehao' &&
                    key != 'tiktok' &&
                    key != 'toutiao' &&
                    $scope.selectChanel[i].key == key
                ) {
                    return i;
                }
                if (
                    (key == 'weixin' || key == 'weibo' || key == 'baijiahao' || key == 'qiehao' || key == 'tiktok' || key == 'toutiao') &&
                    $scope.selectChanel[i].id == id
                ) {
                    return i;
                }
            }
            return -1;
        }

        /**
         * @description: 导航栏右移
         * @param {type}
         * @return:
         */
        $scope.navToRight = function () {
            if ($scope.status.isNavMove) {
                return;
            }
            $scope.status.isNavMove = true;
            if ($scope.status.accessibleChannel - $scope.status.rightCount < 7) {
                $scope.status.isNavMove = false;
                return;
            }

            var currentMarginLeft = $scope.navStyle['margin-left'];
            var nextMarginLeft = parseInt(currentMarginLeft.replace('px', '')) - 94 + 'px';
            $scope.navStyle['margin-left'] = nextMarginLeft;
            $scope.status.rightCount++;
            $scope.status.isNavMove = false;
        };

        /**
         * @description: 导航栏左移
         * @param {type}
         * @return:
         */
        $scope.navToLeft = function () {
            if ($scope.status.isNavMove) {
                return;
            }
            $scope.status.isNavMove = true;
            if ($scope.status.rightCount === 0) {
                $scope.status.isNavMove = false;
                return;
            }

            var currentMarginLeft = $scope.navStyle['margin-left'];
            var nextMarginLeft = parseInt(currentMarginLeft.replace('px', '')) + 94 + 'px';
            $scope.navStyle['margin-left'] = nextMarginLeft;
            $scope.status.rightCount--;
            $scope.status.isNavMove = false;
        };

        /**
         * @description: 计算有权限访问渠道数量
         * @param {type}
         * @return:
         */
        function calcuAccessbleChannel() {
            var count = 0;
            for (let i in $scope.status.accessAuthority) {
                if ($scope.status.accessAuthority[i] === true) {
                    count++;
                }
            }
            // if(!$scope.status.isShowWeibo){
            //     count--;
            // }
            $scope.status.accessibleChannel = count;
        }
    },
]);
